import { render, staticRenderFns } from "./ReportPoints.vue?vue&type=template&id=0ccadd5c"
import script from "./ReportPoints.vue?vue&type=script&lang=js"
export * from "./ReportPoints.vue?vue&type=script&lang=js"
import style0 from "./ReportPoints.vue?vue&type=style&index=0&id=0ccadd5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports